import { render } from "./statuteAdd.vue?vue&type=template&id=1691227f&scoped=true"
import script from "./statuteAdd.vue?vue&type=script&lang=js"
export * from "./statuteAdd.vue?vue&type=script&lang=js"

import "./statuteAdd.vue?vue&type=style&index=0&id=1691227f&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1691227f"]])

export default __exports__